import React from "react";
import "./Terms.css";
import { Container } from "react-bootstrap";

function Terms() {
  return (
    <>
      <section className="terms">
        <div className="terms_banner">
          <div className="baner_text">
            <h1>Terms & Conditions</h1>
            <p>Last Updated: Feb 20, 2022</p>
          </div>
        </div>
        <Container>
          <div className="terms_info">
            <p>
              This Privacy Policy document contains types of information that is
              collected and recorded by us and how we use it.
            </p>
            <h3>General information</h3>
            <p>
              One of our main priorities is the privacy of our visitors. This
              Privacy Policy document contains types of information that is
              collected and recorded by KeyDesign and how we use it.
            </p>
            <p>
              If you have additional questions or require more information about
              our Privacy Policy, do not hesitate to contact us through email at
              Incubator. An example of a privacy policy can be found at
              buyproxies.io.
            </p>
            <h3>Log files</h3>
            <p>
              KeyDesign follows a standard procedure of using log files. These
              files log visitors when they visit websites. All hosting companies
              do this and a part of hosting services’ analytics. The information
              collected by log files include:
            </p>
            <ul>
              <li>Internet protocol (IP) addresses </li>
              <li>Browser type, Internet Service Provider (ISP) </li>
              <li>Date and time stamp, referring/ exit pages </li>
              <li>Possibly the number of clicks </li>
            </ul>

            <h3>Privacy policies</h3>
            <p>
              You may consult this list to find the Privacy Policy for each of
              the advertising partners of Incubator.
            </p>

            <p>
              Third-party ad servers or ad networks uses technologies like
              cookies, JavaScript, or Web Beacons that are used in their
              respective advertisements and links that appear on Incubator,
              which are sent directly to users’ browser. They automatically
              receive your IP address when this occurs. These technologies are
              used to measure the effectiveness of their advertising campaigns
              and/or to personalize the advertising content that you see on
              websites that you visit.
            </p>
            <p>
              Note that KeyDesign has no access to or control over these cookies
              that are used by third-party advertisers.
            </p>
            <h3>Third party policies</h3>
            <p>
              Incubator’s Privacy Policy does not apply to other advertisers or
              websites. Thus, we are advising you to consult the respective
              Privacy Policies of these third-party ad servers for more detailed
              information. It may include their practices and instructions about
              how to opt-out of certain options. You may find a complete list of
              these Privacy Policies and their links here: Privacy Policy Links.
            </p>
            <p>
              You can choose to disable cookies through your individual browser
              options. To know more detailed information about cookie management
              with specific web browsers, it can be found at the browsers’
              respective websites. What Are Cookies?
            </p>
            <h3>Children Information</h3>
            <p>
              Another part of our priority is adding protection for children
              while using the internet. We encourage parents and guardians to
              observe, participate in, and/or monitor and guide their online
              activity.
            </p>
            <p>
              Incubator does not knowingly collect any Personal Identifiable
              Information from children under the age of 13. If you think that
              your child provided this kind of information on our website, we
              h3ly encourage you to contact us immediately and we will do our
              best efforts to promptly remove such information from our records.
            </p>
            <h3>Online privacy</h3>
            <p>
              This privacy policy applies only to our online activities and is
              valid for visitors to our website with regards to the information
              that they shared and/or collect in KeyDesign. This policy is not
              applicable to any information collected offline or via channels
              other than this website.
            </p>
            <p>
              By using our website, you hereby consent to our Privacy Policy and
              agree to its Terms and Conditions.
            </p>

            <h3>Update</h3>
            <p>
              This Privacy Policy was last updated on May 20, 2016. If there
              will be any update, amendment, or changes to our Privacy Policy
              then these will be posted on this pagees
            </p>
          </div>
        </Container>
      </section>
    </>
  );
}

export default Terms;
